import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AnalyticsEvents, AnalyticsCategories, AnalyticsFacebookActions } from '../models/google-analytics';
import { DataService } from './data.service';
import { SentryService } from './sentry.service';
declare let gtag: Function;
declare let fbq: Function;

/**
 * Google Analytics Service transfers "events" into Google Analytics and Facebook Ads so that we can track useful information such as number of signups and revenues
 */
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor(private sentryService: SentryService,private dataService: DataService) { }

  // items must only be filled if eventName is add_to_cart, begin_checkout or purchase
  // transaction_id must only be added for event purchase
  public eventEmitter(eventName: AnalyticsEvents, eventAction: string,
    eventLabel: string = null, eventCategory: AnalyticsCategories, eventValue: number | string = null, items: Array<string> = null, currency = "$", transaction_id = null) {
    let eventParams;
    const currentSite = this.dataService.site$.getValue();
      try {
        this.googleTag('js', new Date());
        this.googleTag('config', currentSite.googleAnalyticsPixel);
        if (eventName === 'purchase' || eventName === 'begin_checkout' || eventName === 'add_to_cart') {
          eventParams = {
            event_category: 'ecommerce',
            items: items,
            event_label: eventLabel,
            currency: currency,
            value: eventValue,
            transaction_id: transaction_id
          };
          if (!environment.production) console.log('If it were in production, it would transmit E-commerce GA Event ' + eventName + ' / ' + eventCategory + ' for items ' + items + ' at a total of ' + eventValue + ' ' + currency);
        }
        // Custom event params
        else {
          eventParams = {
            event_category: eventCategory,
            event_label: eventLabel,
            event_action: eventAction,
            value: eventValue
          };
          if (!environment.production) console.log('If it were in production, it would transmit Custom GA Event ' + eventName + ' ( ' + eventLabel + ') / ' + '/' + eventAction + '/' + eventCategory + ' at a total of ' + eventValue);
        }
        this.googleTag('event', eventName, eventParams);
      } catch (error) {
        if(typeof gtag === undefined){
          this.loadGoogleAnalytics(currentSite.googleAnalyticsPixel);
          setTimeout(()=>{
            this.eventEmitter(eventName,eventAction,eventLabel,eventCategory,eventValue,items,currency,transaction_id);
          },2000);
        }else{
          // Ecommerce event params
          if (eventName === 'purchase' || eventName === 'begin_checkout' || eventName === 'add_to_cart') {
            eventParams = {
              event_category: 'ecommerce',
              items: items,
              event_label: eventLabel,
              currency: currency,
              value: eventValue,
              transaction_id: transaction_id
            };
            if (!environment.production) console.log('If it were in production, it would transmit E-commerce GA Event ' + eventName + ' / ' + eventCategory + ' for items ' + items + ' at a total of ' + eventValue + ' ' + currency);
          }
          // Custom event params
          else {
            eventParams = {
              event_category: eventCategory,
              event_label: eventLabel,
              event_action: eventAction,
              value: eventValue
            };
            if (!environment.production) console.log('If it were in production, it would transmit Custom GA Event ' + eventName + ' ( ' + eventLabel + ') / ' + '/' + eventAction + '/' + eventCategory + ' at a total of ' + eventValue);
          }
          gtag('event', eventName, eventParams);
        }
        this.sentryService.errorHandling(error,'GoogleAnalytics-service',error?(error.error?error.error.message:error.message):error);
      }
  }

  /** Sending data to Facebook Pixel Tag to track revenues on transactions
   * More information at https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking/
   */

  public FbEventEmitter(action: AnalyticsFacebookActions, contentType?: string, contentName?: string, contentCategory?: string, value?: number | string, item?: string, quantity?: number) {
    try {
      this.fbPixel(action, contentType, contentName, contentCategory, value, item, quantity);
    } catch (error) {
      const defaultCurrency = 'USD';
      // Completed purchase transaction
      if(!fbq){
        this.loadFacebook();
        setTimeout(()=>{
          this.FbEventEmitter(action,contentType,contentName,contentCategory,value,item,quantity);
        },2000);
      }else{
        if (action === 'Purchase') {
          if (environment.production) {
            fbq('track', 'Purchase', {
              value: value,
              defaultCurrency: defaultCurrency,
              contents: [
                {
                  id: item,
                  quantity: quantity
                }],
              content_type: contentType
            });
          }
          if (!environment.production) console.log('If it were in production, it would transmit Purchase FB Event ' + action + ' ( ' + contentName + ') / ' + '/' + contentCategory + '/' + item + ' at a total of ' + value + defaultCurrency);
        }
        // Tracking other type of events 
        else {
            fbq('track', action, {
              content_name: contentName,
              content_category: contentCategory,
              content_type: 'product'
            });
        }
      }
      this.sentryService.errorHandling(error,'GoogleAnalytics-service',error?(error.error?error.error.message:error.message):error);
    }
  }
  fbPixel(action: AnalyticsFacebookActions, contentType?: string, contentName?: string, contentCategory?: string, value?: number | string, item?: string, quantity?: number){
    this.load();
    const defaultCurrency = 'USD';
    if (action === 'Purchase') {
      if (environment.production) {
        (window as any).fbq('track', 'Purchase', {
          value: value,
          defaultCurrency: defaultCurrency,
          contents: [
            {
              id: item,
              quantity: quantity
            }],
          content_type: contentType
        });
      }
      if (!environment.production) console.log('If it were in production, it would transmit Purchase FB Event ' + action + ' ( ' + contentName + ') / ' + '/' + contentCategory + '/' + item + ' at a total of ' + value + defaultCurrency);
    }
    else {
      if(1==1){
        (window as any).fbq('track', action, {
            content_name: contentName,
            content_category: contentCategory,
            content_type: 'product'
          });
      }
    }
  }
  load() {
    const currentSite = this.dataService.site$.getValue();
      (function (f: any, b, e, v, n, t, s) {
          if (f.fbq) return; n = f.fbq = function () {
              n.callMethod ?
                  n.callMethod.apply(n, arguments) : n.queue.push(arguments)
          }; if (!f._fbq) f._fbq = n;
          n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
          t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq.disablePushState = true; //not recommended, but can be done
      (window as any).fbq('init', currentSite.facebookPixel);
  }

  loadFacebook(): void {
    const currentSite = this.dataService.site$.getValue();
    if(currentSite.facebookPixel){
      const fbScript = document.createElement('script');
      const fbNoScript = document.createElement('noscript');
      fbScript.innerText = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,\'script\',\'https://connect.facebook.net/en_US/fbevents.js\');fbq(\'init\', \'${ currentSite.facebookPixel }\');fbq(\'track\', \'PageView\');`;
      fbNoScript.innerText = `<img height="1" width="1" style="display:none" src="${currentSite.facebookPixel}" />`;
      
      document.documentElement.firstChild.appendChild(fbScript);
      document.documentElement.firstChild.appendChild(fbNoScript);
    }
  }
  loadGoogleAnalytics(googleAnalyticsPixel: string): void {
    const gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${ googleAnalyticsPixel }`);

    const gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${ googleAnalyticsPixel }\');`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

  loadGoogleAds(trackingID: string): void {
    const gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${ trackingID }`);

    const gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${ trackingID }\');`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

  /** Sending data to Google Ads
   * 
   */

  public AdsEventEmitter(trackingID: string, eventLabel: string = null, eventAction: string = null, eventValue: number | string = null) {

    const currentSite = this.dataService.site$.getValue();
    try {
      this.googleTag('js', new Date());
      this.googleTag('config', currentSite.googleAdwordsPixel.conversionID);
      this.googleTag('event', 'conversion', {
          send_to : trackingID,
          value: eventValue,
          event_label: eventLabel,
          event_action: eventAction
      });
    } catch (error) {
      if(typeof gtag === undefined){
        this.loadGoogleAds(currentSite.googleAdwordsPixel.conversionID);
        setTimeout(()=>{
          this.AdsEventEmitter(trackingID,eventLabel,eventAction,eventValue);
        },2000);
      } else {
        gtag('event', 'conversion', {
            send_to : trackingID,
            value: eventValue,
            event_label: eventLabel,
            event_action: eventAction
        });
      }
      this.sentryService.errorHandling(error,'GoogleAnalytics-service',error?(error.error?error.error.message:error.message):error);
    }
  }
  googleTag(arg1?,arg2?,arg3?){
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push(arguments);
  }
}
